// ── EDIT BEFORE GO-LIVE ──────────────────────────────────────────
// Single source of truth for contact + social. Change here only.
export const SITE = {
  email: "hello@vynlworld.com",
  instagram: "https://instagram.com/vynlworld",
  instagramHandle: "@vynlworld",
  legalName: "VYNLWORLD LTD",
  jurisdiction: "England & Wales",
  city: "Manchester",
  // Only reveal the public interest count once it reaches this threshold.
  interestDisplayThreshold: 25,
};

// Canonical share metadata (kept in one place, no third-party SDKs).
export const SHARE = {
  url: "https://vynlworld.com",
  title: "VYNLWORLD — Your merch. Your rules.",
  text: "The on-demand marketplace for music artists' merch.",
};

export const IMAGES = {
  designer:
    "https://images.unsplash.com/photo-1571455786673-9d9d6c194f90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxibGFjayUyMHQtc2hpcnQlMjBzcG90bGlnaHQlMjBkYXJrfGVufDB8fHx8MTc4NTI1MTU2NHww&ixlib=rb-4.1.0&q=85",
  fan:
    "https://images.unsplash.com/photo-1761098281103-51bf33e39d7f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHx2aW55bCUyMHJlY29yZCUyMGRhcmslMjBtb29keXxlbnwwfHx8fDE3ODUyNTE1NjV8MA&ixlib=rb-4.1.0&q=85",
  artist:
    "https://images.unsplash.com/photo-1544502062-f82887f03d1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxhcnRpc3QlMjBwb3J0cmFpdCUyMHNpbGhvdWV0dGUlMjBkYXJrfGVufDB8fHx8MTc4NTI1MTU2NXww&ixlib=rb-4.1.0&q=85",
};
